import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "filters_parent" }
const _hoisted_2 = { class: "mb-3 d-flex justify-content-between gap-3 min-width-custom" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = { class: "table_search d-flex justify-content-end align-items-center" }
const _hoisted_5 = { class: "d-flex gap-2 align-items-center ms-auto" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["value"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["value"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["value"]
const _hoisted_12 = { key: 3 }
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 4,
  class: "d-flex align-items-end"
}
const _hoisted_15 = { class: "table-responsive data-table theme-scrollbar zero-configuration" }
const _hoisted_16 = { class: "table_style" }
const _hoisted_17 = { class: "table-dark" }
const _hoisted_18 = ["sortable", "onClick"]
const _hoisted_19 = {
  key: 0,
  style: {"width":"260px"},
  class: "col-actions"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["colspan"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "serial_num" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_26 = {
  key: 2,
  class: "d-flex flex-column gap-1"
}
const _hoisted_27 = {
  key: 3,
  class: "d-flex flex-column gap-1"
}
const _hoisted_28 = ["onClick", "disabled"]
const _hoisted_29 = ["onClick", "title", "disabled"]
const _hoisted_30 = {
  key: 7,
  class: "badge bg-info"
}
const _hoisted_31 = {
  key: 0,
  class: "col-actions border-0"
}
const _hoisted_32 = { class: "action_btns d-flex gap-2 justify-content-cneter" }
const _hoisted_33 = ["onClick", "disabled"]
const _hoisted_34 = ["onClick", "disabled"]
const _hoisted_35 = ["onClick", "disabled"]
const _hoisted_36 = { key: 2 }
const _hoisted_37 = ["onClick", "disabled"]
const _hoisted_38 = ["onClick", "disabled"]
const _hoisted_39 = ["onClick", "disabled"]
const _hoisted_40 = { key: 2 }
const _hoisted_41 = ["colspan"]

import {
  ref,
  onMounted,
  watchEffect,
  defineAsyncComponent,
  watch,
} from "vue";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { formatDate } from "@/composables/FormatDate";
import { usePermissions } from "@/composables/usePermissions";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonTable2',
  props: ["tableObj", "title", "permissionKey"],
  emits: [
  "isActive",
  "edit",
  "delete",
  "view",
  "toggleFeatured",
  "publish",
  "unPublish",
  "statusFilter",
  "categoryFilter",
  "priorityFilter",
  "resetFilters",
  "toggle-status",
  "featuredFilter",
  "search",
],
  setup(__props, { emit: __emit }) {

const { canView, canUpdate, canDelete } = usePermissions();

const Card1 = defineAsyncComponent(
  () => import("@/components/commen/card/cardData1.vue")
);
const emit = __emit;

let title = ref("");
const filterQuery = ref<string>("");
const allData = ref([]);
const props = __props;
const sortOrder = ref("asc");
const sortedColumn = ref(null);
const columns = ref([]);
const actions = ref([]);
const table_width = ref("auto");

const isLoading = ref(true);

// filters ref
const showStatusFilter = ref(false);
const showCategoryFilter = ref(false);
const showPriorityFilter = ref(false);
const showResetFilter = ref(false);
const filterStatus = ref("");
const filterCategory = ref("");
const filterPriority = ref("");
const showFeaturedFilter = ref(false);

onMounted(() => {
  allData.value = props.tableObj?.data; 
  columns.value = props.tableObj.columns;
  actions.value = props.tableObj.actions ? props.tableObj.actions : [];
  title.value = props.title;
  table_width.value = props.tableObj.table_width
    ? props.tableObj.table_width
    : "auto";
  isLoading.value = props.tableObj.loading;
  showCategoryFilter.value = props.tableObj.showCategoryFilter
    ? props.tableObj.showCategoryFilter
    : false;
  showPriorityFilter.value = props.tableObj.showPriorityFilter
    ? props.tableObj.showPriorityFilter
    : false;
  showFeaturedFilter.value = props.tableObj.showFeaturedFilter
    ? props.tableObj.showFeaturedFilter
    : false;
  showStatusFilter.value = props.tableObj.showStatusFilter
    ? props.tableObj.showStatusFilter
    : false;
  showResetFilter.value = props.tableObj.showResetFilter
    ? props.tableObj.showResetFilter
    : false;
});

// filters
watchEffect(() => {
  const source = props.tableObj?.data || [];
  let filtered = [...source]; 
  // Text search filter
  const query = filterQuery.value.toLowerCase();
  if (query) {
    filtered = filtered.filter((row) =>
      Object.values(row).some((val) =>
        val?.toString().toLowerCase().includes(query)
      )
    );
  }
  allData.value = filtered;
});

// Pagination
function get_rows() {
  return allData.value;
}

// Sorting
function sortTable(column: string) {
  if (sortedColumn.value === column)
    sortOrder.value = sortOrder.value === "asc" ? "desc" : "asc";
  else (sortedColumn.value = column), (sortOrder.value = "asc");

  allData.value.sort((a, b) => {
    const aValue = a[column];
    const bValue = b[column];
    if (aValue < bValue) return sortOrder.value === "asc" ? -1 : 1;
    if (aValue > bValue) return sortOrder.value === "asc" ? 1 : -1;
    return 0;
  });
}

// table actions
function editRow(row) {
  emit("edit", row);
}
function viewRow(row) {
  emit("view", row);
}
function deleteRow(index) {
  emit("delete", index);
}

function isFeatured(index) {
  emit("toggleFeatured", index);
}

function doPublish(index) {
  emit("publish", index);
}
function doUnPublish(index) {
  emit("unPublish", index);
}

function handleStatusFilter() {
  emit("statusFilter", filterStatus.value);
}
function handlePriorityFilter() {
  emit("priorityFilter", filterPriority.value);
}
function handleResetFilters() {
  filterQuery.value = "";
  filterStatus.value = "";
  filterPriority.value = "";
  filterCategory.value = "";
  emit("resetFilters");
}

function handleCategoryFilter(event) {
  const id = event.target.value; // extract ID
  emit("categoryFilter", id); // emit ID to parent
}

watch(
  () => props.tableObj.loading,
  (newValue) => {
    isLoading.value = newValue;
  },
  { immediate: true }
);

// icon convertor
function getIconClasses(icon: any) {
  if (!icon) return ["fa-regular", "fa-circle-question"]; // null/empty

  // If string: "fa-solid fa-house"
  if (typeof icon === "string") {
    const parts = icon.split(" ");
    // return [getFaPrefix(icon), parts[1] || ""];
  }

  // If object: { prefix: "fa-brands", iconName: "fa-react" }
  if (typeof icon === "object") {
    return [icon.prefix || "fas", icon.iconName || ""];
  }

  return ["fa-regular", "fa-circle-question"]; // fallback
}


// Export
function exportJSON() {
  const blob = new Blob([JSON.stringify(allData.value, null, 2)], {
    type: "application/json",
  });
  saveAs(blob, "table-data.json");
}
function exportCSV() {
  const ws = XLSX.utils.json_to_sheet(allData.value);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, "table-data.csv");
}
function exportExcel() {
  const ws = XLSX.utils.json_to_sheet(allData.value);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, "table-data.xlsx");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                for: "table-complete-search",
                class: "col-form-label"
              }, "Search:", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "table-complete-search",
                type: "text",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterQuery).value = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('search', filterQuery.value)))
              }, null, 544), [
                [_vModelText, filterQuery.value]
              ])
            ])
          ]),
          (showStatusFilter.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterStatus).value = $event)),
                  onChange: handleStatusFilter,
                  class: "form-select form-select-sm"
                }, [
                  _cache[9] || (_cache[9] = _createElementVNode("option", { value: "" }, "All Status", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableObj.allStatusLables, (status) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: status,
                      value: status
                    }, _toDisplayString(status), 9, _hoisted_7))
                  }), 128))
                ], 544), [
                  [_vModelSelect, filterStatus.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (showCategoryFilter.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterCategory).value = $event)),
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (handleCategoryFilter($event))),
                  class: "form-select form-select-sm"
                }, [
                  _cache[10] || (_cache[10] = _createElementVNode("option", { value: "" }, "All Categories", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableObj.categories, (cat) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: cat._id,
                      value: cat._id
                    }, _toDisplayString(cat.title || cat), 9, _hoisted_9))
                  }), 128))
                ], 544), [
                  [_vModelSelect, filterCategory.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (showFeaturedFilter.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filterCategory).value = $event)),
                  onChange: _cache[6] || (_cache[6] = (e) => _ctx.$emit('featuredFilter', e.target.value)),
                  class: "form-select form-select-sm"
                }, [
                  _cache[11] || (_cache[11] = _createElementVNode("option", { value: "" }, "All Categories", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableObj.categories, (cat, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: cat
                    }, _toDisplayString(cat), 9, _hoisted_11))
                  }), 128))
                ], 544), [
                  [_vModelSelect, filterCategory.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (showPriorityFilter.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filterPriority).value = $event)),
                  onChange: handlePriorityFilter,
                  class: "form-select form-select-sm"
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("option", { value: "" }, "All Priority", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableObj.allPriorityLables, (priority) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: priority,
                      value: priority
                    }, _toDisplayString(priority), 9, _hoisted_13))
                  }), 128))
                ], 544), [
                  [_vModelSelect, filterPriority.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (showResetFilter.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("button", {
                  class: "btn btn-secondary btn-sm",
                  onClick: handleResetFilters
                }, " Reset ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", { class: "d-flex gap-2" }, [
          _createElementVNode("button", {
            class: "btn btn-primary btn-sm",
            onClick: exportJSON
          }, " Export JSON "),
          _createElementVNode("button", {
            class: "btn btn-success btn-sm",
            onClick: exportCSV
          }, " Export CSV "),
          _createElementVNode("button", {
            class: "btn btn-warning btn-sm",
            onClick: exportExcel
          }, " Export Excel ")
        ])
      ])
    ]),
    _createVNode(_unref(Card1), {
      colClass: "col-sm-12",
      cardhaderClass: "pb-0 pb-0 card-no-border",
      pre: "f-m-light mt-1",
      title: _unref(title),
      span: "true",
      spanClass: _ctx.desc
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("table", {
              class: "display table dataTable no-footer table-bordered fix-wrap",
              id: "basic-1",
              style: _normalizeStyle({ minWidth: table_width.value })
            }, [
              _createElementVNode("thead", _hoisted_17, [
                _createElementVNode("tr", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("th", {
                    scope: "col",
                    style: {"width":"70px"}
                  }, "Sr No", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (column, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: index,
                      sortable: column.sortable,
                      onClick: ($event: any) => (sortTable(column.field)),
                      style: _normalizeStyle({
                  cursor: column.sortable ? 'pointer' : 'default',
                  width: column.width || 'auto',
                })
                    }, _toDisplayString(column.name), 13, _hoisted_18))
                  }), 128)),
                  (actions.value[0])
                    ? (_openBlock(), _createElementBlock("th", _hoisted_19, " Action "))
                    : _createCommentVNode("", true)
                ])
              ]),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        colspan: columns.value.length + (actions.value[0] ? 2 : 1),
                        class: "text-center py-4"
                      }, [...(_cache[14] || (_cache[14] = [
                        _createElementVNode("div", {
                          class: "spinner-border text-primary",
                          role: "status"
                        }, [
                          _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                        ], -1)
                      ]))], 8, _hoisted_21)
                    ])
                  ]))
                : (get_rows().length)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(get_rows(), (row, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(index + 1), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (column, colIndex) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: colIndex,
                              class: "wrap-cell"
                            }, [
                              (column.field === 'icon')
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    class: _normalizeClass(getIconClasses(row[column.field]))
                                  }, null, 2))
                                : (column.field === 'featured_image')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (row[column.field])
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: row[column.field],
                                            alt: "feature image",
                                            style: {"width":"70px","height":"40px","object-fit":"cover","border-radius":"4px","border":"6px solid #fff"}
                                          }, null, 8, _hoisted_24))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_25, "—"))
                                    ], 64))
                                  : (column.field === 'views')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                        _createElementVNode("small", null, [
                                          _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-eye me-1" }, null, -1)),
                                          _createTextVNode(_toDisplayString(row[column.field].view_count), 1)
                                        ]),
                                        _createElementVNode("small", null, [
                                          _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-heart me-1" }, null, -1)),
                                          _createTextVNode(_toDisplayString(row[column.field].like_count), 1)
                                        ]),
                                        _createElementVNode("small", null, [
                                          _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-share me-1" }, null, -1)),
                                          _createTextVNode(_toDisplayString(row[column.field].share_count), 1)
                                        ])
                                      ]))
                                    : (column.field === 'featured')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                          _createElementVNode("button", {
                                            class: _normalizeClass(["btn btn-sm", 
                        row.is_featured ? 'btn-warning' : 'btn-outline-warning'
                      ]),
                                            style: {"cursor":"pointer"},
                                            onClick: ($event: any) => (isFeatured(row._id)),
                                            disabled: __props.permissionKey && !_unref(canUpdate)(__props.permissionKey)
                                          }, [
                                            _createElementVNode("i", {
                                              class: _normalizeClass(row.is_featured ? 'fas fa-star' : 'far fa-star')
                                            }, null, 2)
                                          ], 10, _hoisted_28)
                                        ]))
                                      : (column.field === 'category' &&  row[column.field]?.title )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                            _createTextVNode(_toDisplayString(row[column.field]?.title || ""), 1)
                                          ], 64))
                                        : (column.field === 'date' || column.field === 'lastmod' || column.field === 'created_at')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                              _createTextVNode(_toDisplayString(_unref(formatDate)(row[column.field])), 1)
                                            ], 64))
                                          : (column.type === 'toggle_status')
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 6,
                                                class: _normalizeClass(["btn btn-sm", 
                      row.is_active ? 'btn-success' : 'btn-outline-danger'
                    ]),
                                                onClick: ($event: any) => (_ctx.$emit('toggle-status', row._id, !row.is_active)),
                                                title: row.is_active ? 'Deactivate' : 'Activate',
                                                disabled: __props.permissionKey && !_unref(canUpdate)(__props.permissionKey)
                                              }, [
                                                _createElementVNode("i", {
                                                  class: _normalizeClass(row.is_active ? 'fa fa-check' : 'fa fa-times')
                                                }, null, 2)
                                              ], 10, _hoisted_29))
                                            : (column.type === 'badge')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(row[column.field]), 1))
                                              : (_openBlock(), _createElementBlock("span", {
                                                  key: 8,
                                                  class: _normalizeClass({
                      published_tag: row[column.field] === 'published',
                      draft_tag: row[column.field] === 'draft',
                      scheduled_tag: row[column.field] === 'scheduled',
                      archived_tag: row[column.field] === 'archived',
                    })
                                                }, _toDisplayString(row[column.field]), 3))
                            ]))
                          }), 128)),
                          (actions.value[0])
                            ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                  _renderSlot(_ctx.$slots, "extra-actions", { row: row }),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-primary",
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (viewRow(row)),
                                    disabled: __props.permissionKey && !_unref(canView)(__props.permissionKey)
                                  }, [...(_cache[18] || (_cache[18] = [
                                    _createElementVNode("i", { class: "icofont icofont-eye-alt" }, null, -1)
                                  ]))], 8, _hoisted_33),
                                  (row.isBlog)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-sm btn-outline-success",
                                        style: {"cursor":"pointer"},
                                        onClick: ($event: any) => (editRow(row._id)),
                                        disabled: __props.permissionKey && !_unref(canUpdate)(__props.permissionKey)
                                      }, [...(_cache[19] || (_cache[19] = [
                                        _createElementVNode("i", { class: "icofont icofont-edit" }, null, -1)
                                      ]))], 8, _hoisted_34))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "btn btn-sm btn-outline-success",
                                        style: {"cursor":"pointer"},
                                        onClick: ($event: any) => (editRow(row)),
                                        disabled: __props.permissionKey && !_unref(canUpdate)(__props.permissionKey)
                                      }, [...(_cache[20] || (_cache[20] = [
                                        _createElementVNode("i", { class: "icofont icofont-edit" }, null, -1)
                                      ]))], 8, _hoisted_35)),
                                  (row.status)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        (row.status === 'draft')
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              onClick: ($event: any) => (doPublish(row._id)),
                                              class: "btn btn-sm btn-outline-info",
                                              title: "Publish",
                                              disabled: __props.permissionKey && !_unref(canUpdate)(__props.permissionKey)
                                            }, [...(_cache[21] || (_cache[21] = [
                                              _createElementVNode("i", { class: "fas fa-paper-plane" }, null, -1)
                                            ]))], 8, _hoisted_37))
                                          : (row.status === 'published')
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                onClick: ($event: any) => (doUnPublish(row._id)),
                                                class: "btn btn-sm btn-outline-warning",
                                                title: "Unpublish",
                                                disabled: __props.permissionKey && !_unref(canUpdate)(__props.permissionKey)
                                              }, [...(_cache[22] || (_cache[22] = [
                                                _createElementVNode("i", { class: "fas fa-pause" }, null, -1)
                                              ]))], 8, _hoisted_38))
                                            : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-danger",
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (deleteRow(row._id)),
                                    disabled: __props.permissionKey && !_unref(canDelete)(__props.permissionKey)
                                  }, [...(_cache[23] || (_cache[23] = [
                                    _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                                  ]))], 8, _hoisted_39)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_40, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          colspan: columns.value.length + (actions.value[0] ? 2 : 1),
                          class: "text-center py-5"
                        }, [...(_cache[24] || (_cache[24] = [
                          _createElementVNode("i", { class: "fas fa-book fa-3x text-muted mb-3" }, null, -1),
                          _createElementVNode("h5", { class: "text-muted" }, "No records found", -1)
                        ]))], 8, _hoisted_41)
                      ])
                    ]))
            ], 4)
          ])
        ])
      ]),
      _: 3
    }, 8, ["title", "spanClass"])
  ], 64))
}
}

})